import type { LayerProps } from 'react-map-gl';
import Pin from './mapPin';

export const clusterLayer: LayerProps = {
  id: 'clusters',
  type: 'circle',
  // type: 'symbol',
  source: 'earthquakes',
  filter: ['has', 'point_count'],
  paint: {
    'circle-color': ['step', ['get', 'point_count'], '#51bbd6', 100, '#f1f075', 750, '#f28cb1'],
    'circle-radius': ['step', ['get', 'point_count'], 20, 100, 30, 750, 40]
  }
  // layout: {
  //   "icon-image": "marker-11",
  //   "icon-size": 3
  // }
};

export const clusterCountLayer: LayerProps = {
  id: 'cluster-count',
  type: 'symbol',
  source: 'earthquakes',
  filter: ['has', 'point_count'],
  layout: {
    'text-field': '{point_count_abbreviated}',
    'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
    'text-size': 12
  }
};

export const unclusteredPointLayer: LayerProps = {
  id: 'unclustered-point',
  type: 'circle',
  // type: 'symbol',
  source: 'earthquakes',
  filter: ['!', ['has', 'point_count']],
  // layout: {
  //   "icon-image": "marker-11",
  //   "icon-size": 3
  // }
  paint: {
    'circle-color': '#11b4da',
    'circle-radius': 8,
    'circle-stroke-width': 1,
    'circle-stroke-color': '#fff'
  }
};
